import * as ActionTypes from '../../actions/CartActions';

const isProcessingCart = (state = false, action) => {
  switch(action.type) {
    case ActionTypes.HANDLE_CLEAR_FAULTY_CART_REQUEST:
      return true;

    case ActionTypes.HANDLE_CLEAR_FAULTY_CART_SUCCESS:
    case ActionTypes.HANDLE_CLEAR_FAULTY_CART_FAILURE:
      return false;

    default:
      return state;
  }
};

export default isProcessingCart;



// WEBPACK FOOTER //
// ./src/cart/reducers/isProcessingCart/index.js